// extracted by mini-css-extract-plugin
module.exports = {"UltraSavings-detail":"UltraSavings_UltraSavings-detail__ukxyu"};